/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BlogPostDto } from '../../models/blog-post-dto';

export interface GetPost$Params {
  slug: string;
}

export function getPost(http: HttpClient, rootUrl: string, params: GetPost$Params, context?: HttpContext): Observable<StrictHttpResponse<BlogPostDto>> {
  const rb = new RequestBuilder(rootUrl, getPost.PATH, 'get');
  if (params) {
    rb.path('slug', params.slug, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BlogPostDto>;
    })
  );
}

getPost.PATH = '/api/v1/blog/posts/{slug}';
